import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ERROR_ICON_COLOR, WARNING_ICON_COLOR } from '../../constants';
import { isCustomIcon } from '../../custom-icons';
import { WorkflowStepInterface } from '@vendasta/automata';

@Component({
  selector: 'automata-automation-node-icon',
  template: `
    <div
      class="type-icon"
      *ngIf="icon()"
      [ngClass]="{
        'type-icon-with-name': !!step()?.name,
        'type-icon-without-name': !step()?.name,
        'type-icon-row': iconMode() === 'row',
        enabled: enabled(),
      }"
      [ngStyle]="{
        background: hasError() ? errorIconColor() : hasWarning() ? warningIconColor() : iconColor(),
      }"
    >
      <ng-container *ngIf="isCustomIcon(icon()!); else defaultIconTemplate">
        <mat-icon [svgIcon]="icon()"></mat-icon>
      </ng-container>
      <ng-template #defaultIconTemplate>
        <mat-icon>{{ icon() }}</mat-icon>
      </ng-template>
    </div>
  `,
  styleUrls: ['./automation-node-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule],
})
export class AutomationNodeIconComponent {
  icon = input<string | undefined>();
  iconColor = input<string>('');
  iconMode = input<'circle' | 'row'>('circle');
  enabled = input<boolean>(true);
  step = input<WorkflowStepInterface | undefined>();
  hasError = input<boolean>();
  hasWarning = input<boolean>();
  errorIconColor = input<string>(ERROR_ICON_COLOR);
  warningIconColor = input<string>(WARNING_ICON_COLOR);

  isCustomIcon(name: string): boolean {
    return isCustomIcon(name);
  }
}
